import React, { FunctionComponent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IAiAssistantContent } from '../../models/ai-assistant.models';
import { DATA_QA } from '../../helpers/data-qa';
import ReadyForExtractionIcon from '../../../NewsForge/components/subComponents/news-forge-process-images/news-forge-ready-icon';
import InProgressExtractionIcon from '../../../NewsForge/components/subComponents/news-forge-process-images/news-forge-inprogress-icon';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../../store/store';
import { hasBodyText, hasValidExtractedContent, isArticleEdit } from '../../helpers/ai-assistant.helper';

type FieldType = 'main_title' | 'summary' | 'seo_title';

type Properties = {
	aiAssistantContent: IAiAssistantContent;
	isExtracting: boolean;
	isRegenerating?: boolean;
	hasError?: boolean;
	field: FieldType;
};

const AiAssistantOperationsContainer: FunctionComponent<Properties> = ({
	aiAssistantContent,
	isExtracting,
	isRegenerating,
	hasError,
	field,
}) => {
	const { t } = useTranslation();
	const state = useSelector((state: AppState) => state);

	const currentArticle = useMemo(() => {
		if (isArticleEdit() && state.tempArticle && state.tempArticle.articleEdit) {
			return state.tempArticle.articleEdit;
		}
		return state.tempArticle.article;
	}, [state.tempArticle]);

	const noBodyText = useMemo(() => {
		return hasBodyText(currentArticle);
	}, [currentArticle]);

	const hasExtractedContent = useMemo(() => {
		return hasValidExtractedContent(aiAssistantContent, field);
	}, [aiAssistantContent, field]);

	return (
		<div className='ai-assistant-operations-container' data-qa={DATA_QA.AI_TOOLS_PANEL_OPERATIONS_CONTAINER}>
			{isExtracting && !hasExtractedContent ? (
				<>
					<InProgressExtractionIcon />
					<span className='ai-assistant-info-label'>{t(isRegenerating ? 'preparing_suggestions' : 'preparing_suggestions')}</span>
				</>
			) : hasError ? (
				<>
					<ReadyForExtractionIcon />
					<span className='ai-assistant-info-label'>{t('ai_tools_service_down')}</span>
				</>
			) : (
				<>
					<ReadyForExtractionIcon />
					{noBodyText ? (
						<span className='ai-assistant-info-label'>{t('suggestions_not_possible')}</span>
					) : (
						<span className='ai-assistant-info-label'>{t('generate_suggestions')}</span>
					)}
				</>
			)}
		</div>
	);
};

export default AiAssistantOperationsContainer;
